<template>
    <v-dialog v-model="modalvenues" max-width="700" >
       <v-layout style="background:white" column>
           <v-layout style="margin:10px">
               <v-flex xs12>
                    <v-text-field v-model="inputsearchvenues" @keyup="searchofficebyname" placeholder="BUSCAR SEDES" class="fas fa-search"></v-text-field>
               </v-flex>
           </v-layout>
            <div  style="overflow-y: scroll; height: 300px;margin-top:0px" class="scrollmenucompany">
                <div  v-for="datacompanysearched in datacompanysearched" :key="datacompanysearched.length">
                    <v-flex xs12>
                        <v-layout>
                            <v-flex xs12 sm5 >
                                <v-card-title primary-title>
                                    <div>
                                    <label style="font-size:30px; font-weight:bold">{{datacompanysearched.name}}</label>
                                        <div>
                                            <label style="font-size:20px">{{datacompanysearched.address}}</label>
                                        </div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                        <v-card-actions style="margin-left:10px">
                            <v-layout row >
                                <v-flex>
                                    <v-btn color="info">Ver Servicios</v-btn>
                                </v-flex>
                            </v-layout> 
                        </v-card-actions>
                        <v-divider light></v-divider>
                    </v-flex>
                </div>
            </div>
            <v-layout class="text-xs-right">
                <v-flex>
                    <v-btn color="primary" @click="modalvenues = false">SALIR</v-btn>
                </v-flex>
            </v-layout>
       </v-layout>
    </v-dialog>
</template>

<script>
import { EventBus } from '../../../helpers/eventbus/event-bus.js'
export default {

     data(){
        return{
                n:2,
                modalvenues: false,
                searchedcompanydata: [],
                datacompanysearched:[],
                inputsearchvenues: '',
                datacompany: null

            }
        },

        mounted(){
            EventBus.$on('openmodalvenues', (datacompany) => {
                this.openmodalvenues()
                this.datacompany = datacompany
                this.getCompany(datacompany)
                //console.log(id)
                
            })
    },
    methods: {
        getCompany(datacompany){
            this.axios.get(`company/searchbyrucornamecompany/${datacompany}`)
                .then((res)=>{
                    //console.log(res.data.company)
                    this.searchedcompanydata = res.data.company.office
                    this.datacompanysearched = res.data.company.office
                    //this.fourdatasearchedcompanydata = this.searchedcompanydata[0].office.slice(0,4)
                    //console.log(this.searchedcompanydata[0].office.slice(0,3))
                })
        },
        openmodalvenues(){
            this.modalvenues= true
        },
        
        searchofficebyname(){
            if(this.inputsearchvenues === ''){
                this.getCompany(this.datacompany)
            }
            this.datacompanysearched= this.datacompanysearched.filter((datacompanysearched)=>{
                let regexsearch = new RegExp(this.inputsearchvenues, 'ig')
                return datacompanysearched.name.match(regexsearch)
            })
        }
    } 
}
</script>

